import React, { Fragment } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import {
  APPLY_PROJECT_PATH,
  APPLY_SOLICITUDE_PATH,
  APPLY_NEEDS_PATH,
  APPLY_PEOPLE_PATH,
  APPLY_INFO_PATH
} from '../../../MainRoutes/constants'
import { stepStatuses } from '../../constants'

import withFormikStep from '../enhancers/withFormikStep'
import ProjectStepNav from './StepNav'
import SolicitudeForm from './Forms/SolicitudeForm'
import NeedsForm from './Forms/NeedsForm'
import PeopleForm from './Forms/PeopleForm'
import InfoForm from './Forms/InfoForm'

const EnhancedSolicitudeForm = withFormikStep({
  step: stepStatuses.SOLICITUDE
})(SolicitudeForm)
const EnhancedNeedsForm = withFormikStep({
  step: stepStatuses.NEEDS
})(NeedsForm)
const EnhancedPeopleForm = withFormikStep({
  step: stepStatuses.PEOPLE
})(PeopleForm)
const EnhancedInforForm = withFormikStep({
  step: stepStatuses.INFO
})(InfoForm)

function ProjectRoutes() {
  return (
    <Fragment>
      <ProjectStepNav />
      <Switch>
        <Route path={APPLY_SOLICITUDE_PATH} component={EnhancedSolicitudeForm} exact />
        <Route path={APPLY_NEEDS_PATH} component={EnhancedNeedsForm} exact />
        <Route path={APPLY_PEOPLE_PATH} component={EnhancedPeopleForm} exact />
        <Route path={APPLY_INFO_PATH} component={EnhancedInforForm} exact />
        <Redirect from={APPLY_PROJECT_PATH} to={APPLY_SOLICITUDE_PATH} />
      </Switch>
    </Fragment>
  )
}

export default ProjectRoutes
